<template>
  <stripe-checkout
      ref="checkoutRef"
      :pk="publishableKey"
      :session-id="sessionId"/>
</template>

<script>
import { StripeCheckout } from '@vue-stripe/vue-stripe'

export default {
  components: {
    'stripe-checkout': StripeCheckout,
  },
  props: {
    sessionId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      publishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
    }
  },
  mounted() {
    this.submit()
  },
  methods: {
    submit() {
      this.$refs.checkoutRef.redirectToCheckout()
    },
  },
}
</script>